import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocalizedTemplates, categories, Template } from '../data/templates';
import './TemplatesPage.css';

const TemplatesPage: React.FC = () => {
  const { t, i18n } = useTranslation('landing');
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const localizedTemplates = getLocalizedTemplates(i18n.language);
  const filtered: Template[] =
    activeCategory === 'all'
      ? localizedTemplates
      : localizedTemplates.filter((tpl) => tpl.category === activeCategory);

  return (
    <div className="templates-page">
      <div className="templates-hero">
        <h1>{t('templates.page_title')}</h1>
        <p>{t('templates.page_subtitle')}</p>
      </div>

      <div className="templates-container">
        <div className="templates-filters">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`templates-filter-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {t(`templates.${cat}`)}
            </button>
          ))}
        </div>

        <div className="templates-grid">
          {filtered.map((tpl) => (
            <Link
              key={tpl.slug}
              to={`/templates/${tpl.slug}`}
              className="template-card"
            >
              <div className="template-card-icon">
                <i className={tpl.icon}></i>
              </div>
              <div className="template-card-body">
                <span className="template-card-category">
                  {t(`templates.${tpl.category}`)}
                </span>
                <h3 className="template-card-title">{t(tpl.nameKey)}</h3>
                <p className="template-card-desc">{t(tpl.descKey)}</p>
              </div>
              <div className="template-card-footer">
                <span className="template-card-cta">
                  {t('templates.open_in_editor')} <i className="fas fa-arrow-right"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TemplatesPage;
